var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonEventsList/CommonEventsList.jinja"] = require( "front/components/CommonEventsList/CommonEventsList.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/EventsList/EventsList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/EventsList/EventsList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonEventsList/CommonEventsList.jinja", false, "assets/app/front/components/EventsList/EventsList.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonEventsList")) {
var t_7 = t_4.CommonEventsList;
} else {
cb(new Error("cannot import 'CommonEventsList'")); return;
}
context.setVariable("CommonEventsList", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"EventsList\" data-id=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_9 += "\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\">\n        <h2>";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_9 += "</h2>\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"preview_cover")) {
t_9 += "\n          <figure>\n              <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"preview_cover")),"w680_url"), env.opts.autoescape);
t_9 += "\"\n                srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"preview_cover")),"w1366_url"), env.opts.autoescape);
t_9 += " 1366w,\n                        ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"preview_cover")),"w680_url"), env.opts.autoescape);
t_9 += " 680w\"\n                sizes=\"(max-width: 759px) 1, ";
t_9 += "\n                       100vw\"\n                alt=\"\">\n              <figcaption>";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"preview_content_rendered")), env.opts.autoescape);
t_9 += "</figcaption>\n          </figure>\n        ";
;
}
else {
t_9 += "\n          <div class=\"EventsList-line\"></div>\n        ";
;
}
t_9 += "\n\n        ";
if((lineno = 21, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"upcoming_events")),"count"), "data[\"upcoming_events\"][\"count\"]", context, []))) {
t_9 += runtime.suppressValue((lineno = 22, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonEventsList"), "CommonEventsList", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"upcoming_events")})])), env.opts.autoescape);
t_9 += "\n        ";
;
}
else {
t_9 += "\n          <div class=\"EventsList-noEvents\">No Upcoming Events</div>\n        ";
;
}
t_9 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("EventsList");
context.setVariable("EventsList", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/EventsList/EventsList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/EventsList/EventsList.jinja
// module id = 479
// module chunks = 0